import { groupsActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',
  CheckBackBtn: false,
  groupsByPagination: {
    data: {
      pageNo: 1,
    },
  },
  createGroup: {
    data: {},
    message: '',
  },
  groupDetails: {
    data: {},
    message: '',
    isLoadingDetails:false,
  },
  groupNames: {
    data: [],
  },
  bulkUsersAssociation: {
    status: false,
    message: '',
  },
  groupDeleteData: {
    message: '',
  },
};

const GroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.FETCH_GROUPS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTION.FETCH_GROUP_DETAILS_REQUEST:
      return {
        ...state,
        groupDetails:{
          ...state.groupDetails,
          isLoadingDetails:true,
        }
      };
    case ACTION.FETCH_GROUPS_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        groupsByPagination: {
          ...state.groupsByPagination,
          data: action.payload,
        },
      };
    case ACTION.FETCH_GROUPS_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case ACTION.CREATE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        createGroup: {
          ...state.createGroup,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.CREATE_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        createGroup: {
          data: {},
          message: '',
        },
        error: action.payload,
      };

    case ACTION.REMOVE_GROUPS_POPUP:
      return {
        ...state,
        loading: false,
        createGroup: {
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.GROUP_START_FETCH:
      return { ...state, loading: true };
    case ACTION.FETCH_GROUP_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        groupDetails: {
          ...state.groupDetails,
          data: action.payload,
          message: '',
          isLoadingDetails:false,
        },
        error: '',
      };
    case ACTION.GROUP_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.GROUP_DETAILS_SET_ERROR:
      return {
        ...state,
        groupDetails: {
          ...state.groupDetails,
          isLoadingDetails:false,
          message: action.payload,
        },
      };
    case ACTION.FETCH_GROUP_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        groupDetails: {
          data: {},
          message: action.payload,
          isLoadingDetails:false,
        },
        error: '',
      };

    case ACTION.UPDATE_GROUP_SUCCESS:
      return {
        ...state,
        groupDetails: {
          ...state.groupDetails,
          message: action.payload,
          isLoadingDetails:false,
        },
        error: '',
      };

    case ACTION.UPDATE_GROUP_FAILURE:
      return {
        ...state,
         groupDetails: {
          ...state.groupDetails,
          message: action.payload,
          isLoadingDetails:false,
        },
        error: action.payload,
      };

    case ACTION.REMOVE_GROUP_UPDATE_DATA:
      return {
        ...state,
        loading: false,
        groupDetails: {
          message: '',
          isLoadingDetails:false,
        },
        error: '',
      };
    case ACTION.FETCH_GROUP_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        groupNames: {
          ...state.groupNames,
          data: action.payload,
        },
      };
    case ACTION.FETCH_GROUP_NAMES_FAILURE:
      return {
        ...state,
        loading: false,
        groupNames: {
          ...state.groupNames,
          data: [],
          message: action.payload,
        },
      };
    case ACTION.ASSOCIATE_BULK_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        bulkUsersAssociation: {
          status: action.payload.payload.status,
          message: action.payload.message,
        },
      };
    case ACTION.ASSOCIATE_BULK_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        bulkUsersAssociation: {
          status: false,
          message: '',
        },
      };
    case ACTION.REMOVE_BULK_USERS_SUCCESS_MESSAGE:
      return {
        ...state,
        bulkUsersAssociation: {
          ...state.bulkUsersAssociation,
          message: '',
        },
      };
    case ACTION.ASSOCIATE_BULK_USERS_FAILURE_MESSAGE:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case ACTION.GROUP_DELETE_SUCCESS:
      const { message } = action.payload;
      return {
        ...state,
        loading: false,
        groupDeleteData: {
          message,
        },
        error: '',
      };
    case ACTION.GROUP_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.REMOVE_GROUP_DELETE_DATA:
      return {
        ...state,
        loading: false,
        groupDeleteData: {
          message: '',
        },
        error: '',
      };
    case ACTION.GET_GROUP_BACKBTN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: true,
      };
    case ACTION.GET_GROUP_BACKBTN_FAILURE:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: false,
      };
    default:
      return state;
  }
};

export default GroupsReducer;
